import { combineReducers } from "redux";
import SingleUserReducer from "./Reducers/SingleUserReducer";
import LoginReducer from "./Reducers/LoginReducer";
import PasswordReducer from "./Reducers/PasswordReducer";
import GetDocsReducer from "./Reducers/GetDocsReducer";
import StaffReducer from "./Reducers/StaffReducer";
import FilterReducer from "./Reducers/FilterReducer";
import PosReducer from "./Reducers/PosReducer";
import TestCardReducer from "./Reducers/TestCardReducer";
import DemoReducer from "./Reducers/DemoReducer";
import TestCasesReducer from "./Reducers/TestCasesReducer";
import NipReducer from "./Reducers/NipReducer";
import reducer from "./InwardIteraction/reducer";
import ApiHistoryReducer from "./Reducers/ApiHistoryReducer";
import NipOnboardingReducer from "./Reducers/NipOnboardingReducer";
import OutwardTestReducer from "./Reducers/OutwardTestReducer";

export default combineReducers({
  singleUser: SingleUserReducer,
  singleStaff: StaffReducer,
  auth: LoginReducer,
  password: PasswordReducer,
  docs: GetDocsReducer,
  filters: FilterReducer,
  pos: PosReducer,
  test: TestCardReducer,
  demo: DemoReducer,
  testcases: TestCasesReducer,
  nip: NipReducer,
  inwardInteraction: reducer,
  apiHistory: ApiHistoryReducer,
  nipOnboarding: NipOnboardingReducer,
  outwardTest: OutwardTestReducer,
});
